module.exports = __webpack_public_path__ + "img/pethouse53.a1d60348.jpg";